<template>
	<aside
		class="property"
		:class="{ 'shrink': !isVisible }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<!-- loading full screen -->
			<div class="text-center absolute">
				<loading :active.sync="isUploading" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
					<template slot="before">
						<div class="absolute text-lg loading-logo">
							<img src="/img/icon-512.png" height="20" width="20" class="d-inline-block align-top" alt="Grafias">
						</div>
					</template>
					<template slot="after">
						<div>
							<div class="text-lg loading-text mb-2">{{ $t('Uploading') }} {{ mediaProgress }}%</div>
							<div class="mt-2">
								<button class="btn btn-cancel " @click="onCancel">Cancel</button>
							</div>
						</div>
					</template>
				</loading>
			</div>
			<div class="property-title">
				{{ $t('Lottie Properties') }} - {{  mediaLabel ? mediaLabel.toUpperCase() : 'DEFAULT LOTTIE' }}
			</div>

			<button
				class="btn btn-default btn-sm btn-icon property-toggle"
				@click="isVisible = !isVisible">
				<i class="material-icons" v-if="isVisible">chevron_left</i>
				<i class="material-icons" v-else>chevron_right</i>
			</button>
		</div>
			<div class="property-content pr-2" :class="{'pointer-events-none': isLocked || isActiveEdit  ? isLocked.is_locked || isActiveEdit : true}">
				<div class="form-group mb-5">
					<label class="text-primary">
						{{ $t('Lottie File') }}
					</label>
					<label v-if="isCaching" class="ml-2 is-loading"></label>
					<label v-if="isCached" class="ml-2">
						(cached)
					<check-icon :size="15" fillColor="#08ff00" :title="$t('this media is cached and ready for next play!')"></check-icon>
					</label>
					<div class="d-flex flex-row"
					:class="{ 'upload-wrapper-error': !mediaUrl && !mediaFile && !media && isRequired,
					'upload-wrapper': mediaUrl || mediaFile || media || !isRequired }">
					<div class="mt-4 mr-4 pointer" v-if="mediaUrl || mediaFile || media">
						<i class="material-icons mt-1"  @click="playPreview()" v-if="mediaThumbnail ==='' & mediaType === 'lottie' && !isThumbnailLoad">camera_alt</i>
						<div v-if="isThumbnailLoad" class="pt-2">
							<div class="is-loading"></div>
						</div>
						<img
						class="mr-2 template-long-thumbnail"
						@click="playPreview()"
						v-if="mediaUrl &&  data.type === 'lottie' &&  !isThumbnailLoad"
						:src="mediaThumbnail"
						height="30"
						width="53.33" />
					</div>
					<template v-if="!isUploading && !mediaFile && !media && !mediaUrl" >
						<div class="text-left text-break w-75 mt-4 pointer"
							:class="{'template-center': !mediaFile && !media}">
							<label class="text-underline cur-p text-white">
								<span>Upload</span>
								<input type="file" accept=".json" id="lottieInputMp" class="hidden" @change="onMediaSelected">
							</label>
							<span> Lottie File or Select from </span>
							<span class="text-underline cur-p" @click="openGallery">Gallery</span>
						</div>
					</template>

					<div class="text-left text-break w-75 mt-2 pointer" v-if="isUploading">
							{{ $t('Uploading') }} {{ mediaProgress }}%
					</div>

					<div class="text-left text-break w-75 mt-4 pointer" @click="playPreview()" v-if="media && mediaUrl ==='' && !isUploading">
						{{ media && media.name ? media.name : mediaLabel }}
					</div>

					<div class="text-left text-break w-75 mt-4 pointer" @click="playPreview()"
						v-if="!isUploading && mediaUrl !==''">
						{{ mediaLabel }}
					</div>

					<div class="vertical-line ml-4 mr-4" v-if="mediaUrl !=='' || media || mediaUrl"></div>
					<div class="d-flex flex-column pt-1">
						<div class="pointer" @click="openGallery" v-if="mediaFile || media || mediaUrl"><i class="material-icons">folder</i></div>
						<div class="pointer"  v-if="mediaFile || media || mediaUrl">
							<label class="text-underline cur-p text-white mt-1">
								<span class="material-icons">file_upload</span>
								<input type="file" id="lottieInputMp" accept=".json" class="hidden" @change="onMediaSelected">
							</label>
							</div>
					</div>
				</div>
				<!-- if lottie have assets -->
				<div class="form-group mb-3 mt-3 d-flex">
					<!-- Upload -->
					<label
						:class="{'disabled': !isMediaAsset}"
						class="btn min-w-100 btn-primary mb-0">
						<span class="text-black">{{ $t('Upload Lottie Asset (.zip)') }}</span>
						<input
							accept=".zip"
							type="file"
							class="hidden"
							@change="onMediaSelectedAsset"
							id="lottieAssetInputMp"
						/>
					</label>
					<md-icon v-if="checkAssets" class="icon-4-feedback absolute pt-2 ml-16em">check_circle</md-icon>
				</div>
				<label class="label text-grey" v-if="isMediaAsset">
					{{$t('(Optional) If your lottie has additional media asset, in zip file, without folder and not password protected')}}
				</label>
				<!-- form loop -->
					<custom-input class="mb-3"
							align="left"
							:label="$t('Label')"
							:max="40"
							:restrictChar="true"
							:required="isRequired"
							@blur="saveMedia"
							v-model="mediaLabel"
							@keyenter="saveMedia" />
					<div class="d-flex">
						<md-switch
							class="md-primary mt-0 mb-3 mr-0"
							@change="onKeywordChange"
							v-model="mediaLoop">
							{{ $t('Loop') }}
						</md-switch>
						<div class="col-md-6 ml-a mb-4 pl-1 mr-0 pr-0">
							<custom-input
								type="number"
								field="index"
								:label="$t('Layer')"
								:required="isRequired"
								:max="100"
								:index-duplicated="isIndexDuplicated"
								@blur="saveMedia"
								@keyenter="onInputEnter('layer', ...arguments)"
								v-model="mediaLayerIndex"
							/>
						</div>
					</div>
					<div class="form-group mt-2">
						<position-settings
						:width.sync="mediaWidth"
						:height.sync="mediaHeight"
						:position.sync="mediaPosition"
						:blendmode.sync="blendMode"
						:isRatio.sync="isRatio"
						:x.sync="mediaX"
						:y.sync="mediaY"
						@reset="resetSizePosition"
						@rescale="rescaleSize"
						@change="onKeywordChange"
						@keyenter="saveMedia"
						:type="'lottie'"
					/>
					</div>
					<!-- on complete label -->
					<div class="mt-2">
							<div class="d-flex justify-content-between">
								<div>
									<label class="text-primary">{{ $t('On Complete') }}</label>
								</div>
								<!-- <div class="ml-0 pl-0">
									<md-switch
										class="md-primary mt-0 mb-2 mr-0"
										v-model="isParent"
										@change="saveMedia()">
									</md-switch>
								</div> -->
							</div>
						</div>
					<!-- on complete controller -->
					<div class="">
						<md-menu
							:md-active.sync="isOnComplete"
							class="h-fc col-md-12 pr-0 pl-0"
							md-size="small"
							md-direction="top-start"
							md-align-trigger>
							<div v-if="selectedOnComplete"
								class="form-control cur-p relative mb-4"
								md-menu-trigger>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
								<div class="text-right">
									<div @click.stop="removeOnComplete" class="modal-close-assets absolute delete-complete-add">
										<i class="material-icons">cancel</i>
									</div>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control mb-4"
									:placeholder="$t('Stop (default)')"
									@input="onKeywordChange"
									v-model="keywordSearchOnComplete"
									@click.stop="toggleOnComplete"
								/>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
							</div>
							<md-menu-content id="scrolls-style"
							:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
								'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
								'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
								'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
								}"
								>
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectOnComplete(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<!-- parent controller -->
					<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Parent Controller') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								@change="saveMedia()"
								v-model="isParent">
							</md-switch>
						</div>
					</div>
					</div>
					<div class="d-flex select ">
						<!-- <div class="select w-75 relative">
							<div class="mb-2 mh-60px mr-4">
								<multiselect class="select-input" v-model="parentItem" select-label="" deselect-label="Remove" track-by="id" label="name"
								openDirection="bottom" :optionsLimit="10" placeholder="Search or Select Parent Item" :options="filteredParent" @input="saveMedia()"
								:searchable="true" :allow-empty="true" :show-labels="true" :selectedLabel="''">
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div>
						</div> -->
						<!-- new dropdown select assets -->
						<md-menu
							:md-active.sync="isToggleParent"
							class="h-fc mr-2"
							md-size="small"
							md-direction="bottom-start"
							md-align-trigger>
							<div v-if="selectedParent"
								class="form-control cur-p relative w-230px"
								md-menu-trigger>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
								<div @click.stop="removeParent" class="modal-close-assets absolute delete-assets-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control w-230px"
									:placeholder="$t('Search or Select Parent Item')"
									@input="onKeywordChange"
									v-model="keywordSearchParent"
									@click.stop="toggleParent"
								/>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
							</div>
							<md-menu-content id="scrolls-style" class="macro-content-wrapper-list">
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectParent(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
						<!-- delay -->
						<div class="select">
							<custom-input
								class="form-input mb-3"
								type="number"
								:label="$t('Delay')"
								:min="-15000"
								:max="15000"
								:step="100"
								:suffix="'ms'"
								v-model="childOrder"
								@input="onKeywordChange"
								@keyenter="onInputEnter('delay', ...arguments)"
								@blur="saveMedia"
								:allowNegative="true"
							/>
							<!-- <div class="mb-2 mh-60px">
								<multiselect class="select-input" v-model="childOrder" select-label=""
									track-by="id" label="name" openDirection="bottom" placeholder="No Delay" :options="delayList" @input="saveMedia()"
									:searchable="true" :allow-empty="true" :show-labels="false">
									<span class="arrow-multiselect" slot="caret">
										<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
									</span>
									<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div> -->
						</div>
					</div>
				</div>
			</div>
	</aside>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { mapGetters } from 'vuex';
import localforage from 'localforage';
import checkIcon from 'vue-material-design-icons/CheckCircle.vue';
// import Multiselect from 'vue-multiselect';
import ItemOption from '@/components/ItemOption.vue';
import { getAxiosErrorMessage, duplicateVar, delay } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import fileApi from '@/api/file';
import mediasApi from '@/api/medias';
import CustomInput from '@/components/CustomInput.vue';
import PositionSettings from '@/components/PositionSettings.vue';
import {
	delayList,
} from '@/lib/statics';

export default {
	name: 'LottieProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		media: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			mediaId: '',
			mediaFile: '',
			mediaUrl: '',
			mediaLabel: '',
			mediaLoop: false,
			mediaLayerIndex: 0,
			mediaWidth: 0,
			mediaHeight: 0,
			mediaPosition: '',
			mediaThumbnail: '',
			mediaX: 0,
			mediaY: 0,
			blendMode: 'normal',
			mediaType: 'lottie',
			progress: 0,
			isUploading: false,
			isSaving: false,
			isVisible: true,
			isLoading: false,
			isRequired: false,
			isRatio: true,
			mediaProgress: 0,
			isThumbnailLoad: false,
			mediaAsset: '',
			isMediaAsset: false,
			mediaAssetLabel: '',
			isUploadingAsset: false,
			mediaProgressAsset: false,
			assetsURL: [],
			contentAsset: '',
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			isActiveEdit: false,
			// loader
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			userClient: {},
			hasPlayed: false,
			parentItem: null,
			isParent: false,
			delayList,
			childOrder: 0,
			isCaching: false,
			isCached: false,
			selectedParent: null,
			selectedOnComplete: null,
			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			isToggleParent: false,
			isOnComplete: false,
			// storage warn
			isStorage99Percent: false,
			isStorage80Percent: false,
			currentStorage: false,
			availableStorage: false,
			mediaOriginalWidth: 0,
			mediaOriginalHeight: 0,
		};
	},
	components: {
		CustomInput,
		PositionSettings,
		Loading,
		// Multiselect,
		ItemOption,
		checkIcon,
	},
	methods: {
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		onCancel() {
			if (this.cancelUpload) {
				this.cancelUpload();
				this.mediaFile = null;
				this.isCaching = false;
				this.isCached = false;
				this.isUploading = false;
			}
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		playPreview() {
			if (this.data.is_Locked) return; // Disable when ed
			const id = this.data.id;
			const status = 'preview';
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				// const items = response.data;
			};
			const errorCallback = () => {
			};
			const userActivateAllItem = this.userSettings && this.userSettings.is_enable_all_preview ? this.userSettings.is_enable_all_preview : false;
			const params = {
				isAllItem: userActivateAllItem,
			};
			rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},
		initData() {
			this.reset();
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
					this.contentAsset = content;
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				this.mediaLabel = this.data.name;
				this.mediaLayerIndex = this.data.layer_index;
				if (content) {
					const itemKey = `lottie_media_${content.id}`;
					this.checkCached(itemKey);
					this.mediaUrl = content.url;
					this.mediaId = content.id;
					if (this.mediaUrl) {
						this.lottiedatachange(this.mediaId, this.mediaUrl);
					}
					this.mediaAsset = content.mediaAsset;
					this.mediaAssetLabel = content.mediaAssetLabel;
					this.mediaType = content.type;
					this.mediaLoop = content.loop;
					this.mediaOpacity = content.opacity;
					this.mediaWidth = content.width;
					this.mediaHeight = content.height;
					this.mediaOriginalWidth = content.original_width;
					this.mediaOriginalHeight = content.original_height;
					this.mediaPosition = content.position;
					this.mediaThumbnail = content.thumbnail;
					this.mediaX = content.x;
					this.mediaY = content.y;
					this.isRatio = content.isRatio;
					this.assetsURL = content.assetsURL;
					this.hasPlayed = content.hasPlayed;
					this.isParent = content.isParent || false;
					this.blendMode = content.blendMode;
					// this.parentItem = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder || 0;
				}
			}
		},
		reset() {
			this.mediaId = '';
			this.mediaFile = '';
			this.mediaUrl = '';
			this.mediaType = 'lottie';
			this.mediaLoop = false;
			this.mediaLabel = '';
			this.mediaOpacity = '';
			this.mediaLayerIndex = 0;
			this.mediaWidth = 1920;
			this.mediaHeight = 1080;
			this.mediaPosition = 'default';
			this.mediaThumbnail = '';
			this.mediaX = 0;
			this.mediaY = 0;
			this.hasPlayed = false;
			this.blendMode = 'normal';
		},
		onMediaSelected(e) {
			this.initDataUser();
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // limit 1 gb
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'application/json') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.rundownStorage) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									return;
								}
							// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploading = true;
							const params = new FormData();
							params.append('file', file);
							if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
							const callback = (response) => {
								const mediaUrl = response.data;
								this.mediaUrl = mediaUrl;

								this.hasPlayed = false;
								this.isUploading = false;
								this.mediaProgress = 0;
								if (this.mediaUrl) {
									this.lottieCheckDimension(this.mediaUrl);
								}
								this.lottieCheckDimension(this.mediaUrl);

								if (document.querySelector('#lottieInputMp')) document.querySelector('#lottieInputMp').value = '';
								this.addMedia(this.mediaUrl, file.size / 1048576);
							};
							if (this.rundownStorage) {
								// on the spot 100%
								const resultSizeFile = file.size / oneMB;
								// eslint-disable-next-line
								const isStorageOnTheSpot100 = this.rundownStorage.total_remaining_size == resultSizeFile;
								if (isStorageOnTheSpot100) {
									const message = 'Your total used Storage is 100%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
								}
								// right on 80% mark
								const resultPercentage80 = this.rundownStorage.total_max_file_size * 80 / 100;
								const fixTotalUsageAndFile80 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
								// eslint-disable-next-line
								const isStorageOnTheSpot80 = fixTotalUsageAndFile80 >= resultPercentage80 && this.rundownStorage.total_used_file_size < resultPercentage80;
								if (isStorageOnTheSpot80) {
									const message = 'Your total used Storage is over 80%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									this.isStorage80Percent = true;
									this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage80;
									this.availableStorage = this.rundownStorage.total_max_file_size;
								}
								// right on 99% mark
								const resultPercentage99 = this.rundownStorage.total_max_file_size * 99 / 100;
								const fixTotalUsageAndFile99 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
								// eslint-disable-next-line
								const isStorageOnTheSpot99 = fixTotalUsageAndFile99 >= resultPercentage99 && this.rundownStorage.total_used_file_size < resultPercentage99;
								if (isStorageOnTheSpot99) {
									const message = 'Your total used Storage is over 99%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									this.isStorage99Percent = true;
									this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage99;
									this.availableStorage = this.rundownStorage.total_max_file_size;
								}
							}
							const errorCallback = (e) => {
								const messageFromCallback = getAxiosErrorMessage(e);
								const message = messageFromCallback && messageFromCallback !== '' ? messageFromCallback : 'Error when uploading file';
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
									duration: 999999999,
								});
								this.isUploading = false;
								this.mediaLabel = '';
								this.mediaFile = '';
								this.mediaUrl = '';
								this.mediaThumbnail = '';
								this.mediaAsset = '';
								this.isUploadingAsset = false;
							};
							const progressCallback = (progress) => {
								this.mediaProgress = progress;
							};
							const cancelUploadCallback = (c) => {
								this.cancelUpload = c;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback, cancelUploadCallback);
							this.mediaFile = file;
							// Remove extension from filename to set label
							let filename = duplicateVar(file.name);
							filename = filename.split('.').slice(0, -1).join('.');
							this.mediaLabel = duplicateVar(filename);
							if (document.querySelector('#lottieInputMp')) document.querySelector('#lottieInputMp').value = '';
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#lottieInputMp')) document.querySelector('#lottieInputMp').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#lottieInputMp')) document.querySelector('#lottieInputMp').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onMediaSelectedAsset(e) {
			this.initDataUser();
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // make it "1gb" when no limiter is set
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'application/x-zip-compressed' || files[0].type === 'application/zip') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
						// check storage
							if (this.rundownStorage) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#lottieAssetInputMp')) document.querySelector('#lottieAssetInputMp').value = '';
									return;
								}
								// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploadingAsset = true;
							const params = new FormData();
							params.append('file', file);
							if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
							this.fileSize = files.size / oneMB;
							const callback = (response) => {
								const mediaAsset = response.data;
								this.mediaAsset = mediaAsset;
								this.isUploadingAsset = false;
								this.mediaProgressAsset = 0;

								this.saveMedia();
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.isUploadingAsset = false;
							};
							const progressCallback = (progress) => {
								this.mediaProgressAsset = progress;
							};
							const cancelUploadCallback = (c) => {
								this.cancelUpload = c;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback, cancelUploadCallback);
							// Remove extension from filename to set label
							let filename = duplicateVar(file.name);
							filename = filename.split('.').slice(0, -1).join('.');
							this.mediaAssetLabel = duplicateVar(filename);
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#lottieAssetInputMp')) document.querySelector('#lottieAssetInputMp').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#lottieAssetInputMp')) document.querySelector('#lottieAssetInputMp').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		cacheDisplays() {
			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Media Saved',
					text: `Rebuilding cache for ${this.data.name}`,
				});
			};
			const callbackError = () => {
			};
			const params = {
				display_name: '',
			};
			rundownItemsApi.cacheDisplay(this.data.id, params, callback, callbackError);
		},
		saveMedia(isSame = true) {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				this.isMediaFormVisible = false;
				if (!isSame) this.cacheDisplays();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.params, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.params, callback, errorCallback);
			}
		},
		addMedia(mediaUrl, sizeLottie) {
			// this.isAdding = true;
			this.isThumbnailLoad = true;
			const params = {
				name: this.mediaLabel,
				path: this.mediaUrl,
				type: 'lottie',
				thumbnail: this.mediaThumbnail,
				rundown_id: this.rundown.id || null,
				category_id: 1,
				size: sizeLottie,
			};
			// eslint-disable-next-line no-unused-vars
			const callback = (response) => {
				const item = response.data;
				this.mediaId = item.id;
				this.mediaThumbnail = item.thumbnail;
				const isSame = false;
				this.saveMedia(isSame);
				this.resetCache(this.mediaId, mediaUrl);
				// this.lottiedatachange(this.mediaId, this.mediaUrl);
				this.isThumbnailLoad = false;
				if (this.isStorage80Percent || this.isStorage99Percent) this.notifyEmailStorage();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isThumbnailLoad = false;
				this.availableStorage = 0;
				this.currentStorage = 0;
				// this.isAdding = false;
			};
			mediasApi.create(params, callback, errorCallback);
		},
		notifyEmailStorage() {
			const callback = () => {
				this.availableStorage = 0;
				this.currentStorage = 0;
				this.isStorage99Percent = false;
				this.isStorage80Percent = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
				current_storage: this.currentStorage,
				available_storage: this.availableStorage,
			};
			mediasApi.notifyEmail(params, callback, errorCallback);
		},
		openGallery() {
			this.$emit('browse');
		},
		onKeywordChange() {
			delay(() => {
				this.saveMedia();
			}, 1200);
		},
		async lottieCheckDimension(mediaUrl) {
			const url = mediaUrl;
			if (url) {
				const data = await (await fetch(url)).json();
				if (data) {
					if (data.w && data.h) {
						this.mediaOriginalWidth = data.w;
						this.mediaOriginalHeight = data.h;
						this.mediaWidth = data.w;
						this.mediaHeight = data.h;
						this.saveMedia();
					}
				}
			}
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.mediaLayerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		resetSizePosition() {
			this.mediaX = 0;
			this.mediaY = 0;
			this.mediaPosition = 'default';
			this.mediaWidth = this.mediaOriginalWidth;
			this.mediaHeight = this.mediaOriginalHeight;
			this.saveMedia();
		},
		deactiveTemplateProperty() {
			this.isMediaAsset = false;
		},
		checkCached(itemKey) {
			localforage.getItem(itemKey).then((value) => {
				if (value) {
					let content = this.data.content;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					if (content && content.url) this.isCached = true;
					if (content && content.url) this.isCaching = false;
				} else {
					this.isCached = false;
					this.isCaching = false;
				}
			});
		},
		async lottiedatachange(mediaId, mediaUrl) {
			const url = mediaUrl;
			this.deactiveTemplateProperty();
			if (url) {
				// const data = await (await fetch(url)).json();
				let data = null;
				const lottieKey = `lottie_media_${mediaId}`;
				localforage.getItem(lottieKey).then(async (value) => {
					if (value) {
						data = value;
						this.checkCached(lottieKey);
					} else {
						data = await (await fetch(url)).json();
						// // eslint-disable-next-line no-unused-vars
						// localforage.setItem(lottieKey, data).then(() => {
						// 	// here you can have your logic
						// }).catch(() => {
						// 	// we got an error
						// });
					}

					// this.downloadedTemplate = duplicateVar(data);
					// eslint-disable-next-line
					// $.each(data.layers, (k, obj) => {
					if (Array.isArray(data.assets) && data.assets.length) {
						// array does not exist, is not an array, or is empty
						// ⇒ do not attempt to process array
						this.isMediaAsset = true;
					} else {
						this.isMediaAsset = false;
					}
					this.checkCached(lottieKey);
					// });
				});
			}
		},

		async resetCache(mediaId, url) {
			const lottieKey = `lottie_media_${mediaId}`;
			// console.log(data);
			localforage.getItem(lottieKey).then(async (value) => {
				const data = await (await fetch(url)).json();
				if (!value) {
					// eslint-disable-next-line no-unused-vars
					localforage.setItem(lottieKey, data).then(() => {
						this.checkCached(lottieKey);
					});
				}

				this.checkCached(lottieKey);
			});
			this.lottiedatachange(mediaId, this.mediaUrl);
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
			this.saveMedia();
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
			this.saveMedia();
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
			this.saveMedia();
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
			this.saveMedia();
		},
		onInputEnter(props, value) {
			if (props === 'layer') this.mediaLayerIndex = value;
			if (props === 'delay') this.childOrder = value;
			this.saveMedia();
		},
		rescaleSize() {
			if (this.data.content) {
				const content = JSON.parse(this.data.content);
				const ratio = Math.min(1920 / content.width, 1080 / content.height);
				this.mediaWidth = content.width * ratio;
				this.mediaHeight = content.height * ratio;
				// change position
				this.mediaX = (1920 - this.mediaWidth) / 2;
				this.mediaY = (1080 - this.mediaHeight) / 2;
				this.mediaPosition = 'custom';
				this.saveMedia();
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		params() {
			const mediaLabel = this.mediaLabel.trim();
			// const parentItemId = this.parentItem && this.parentItem.id ? this.parentItem.id : null;
			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;

			const content = {
				id: this.mediaId,
				assetsURL: this.assetsURL,
				url: this.mediaUrl,
				type: this.mediaType,
				loop: this.mediaLoop,
				label: mediaLabel,
				width: this.mediaWidth,
				height: this.mediaHeight,
				original_width: this.mediaOriginalWidth,
				original_height: this.mediaOriginalHeight,
				position: this.mediaPosition,
				thumbnail: this.mediaThumbnail,
				x: this.mediaX,
				y: this.mediaY,
				isRatio: this.isRatio,
				hasPlayed: this.hasPlayed,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				childOrder: this.childOrder,
				blendMode: this.blendMode,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: mediaLabel || 'Default Lottie',
				type: 'lottie',
				content: contentString,
				layer_index: this.mediaLayerIndex,
				rundown_id: this.rundownId,
			};
			if (this.mediaAsset) params.assets_url = this.mediaAsset;
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.mediaLayerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		content() {
			let content = null;
			if (this.data) {
				content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
			}
			return content;
		},
		checkAssets() {
			return this.content && this.content.assetsURL ? this.content.assetsURL.length > 0 : false;
		},
	},
	watch: {
		mediaFile() {
			const type = 'lottie';
			this.mediaType = type;
		},
		data() {
			if (this.data) {
				this.mediaLayerIndex = this.data.layer_index;
				this.mediaLabel = this.data.name;
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				if (content) {
					this.mediaId = content.id;
					this.mediaUrl = content.url;
					// this.checkExist();
					const activeEdit = this.data.active_edit;
					if (activeEdit && activeEdit !== this.userId) {
						this.isActiveEdit = true;
					// this.initData();
					} else {
						this.isActiveEdit = false;
					}

					this.mediaAsset = content.mediaAsset;
					this.mediaAssetLabel = content.mediaAssetLabel;
					this.mediaType = content.type;
					this.mediaLoop = content.loop;
					this.mediaOpacity = content.opacity;
					this.mediaWidth = content.width;
					this.mediaHeight = content.height;
					this.mediaOriginalWidth = content.original_width;
					this.mediaOriginalHeight = content.original_height;
					this.mediaPosition = content.position;
					this.mediaThumbnail = content.thumbnail;
					this.mediaX = content.x;
					this.mediaY = content.y;
					this.isRatio = content.isRatio;
					this.assetsURL = content.assetsURL;
					this.hasPlayed = content.hasPlayed;
					this.isParent = content.isParent;
					this.blendMode = content.blendMode;
					// this.parentItem = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder;
				}
			}
		},
		media() {
			if (this.media) {
				const isSame = this.mediaId === this.media.id;
				this.mediaId = this.media.id;
				this.mediaUrl = this.media.path;
				this.mediaLabel = this.media.name;
				this.mediaType = this.media.type;
				this.mediaThumbnail = this.media.thumbnail;
				if (this.mediaUrl) {
					if (this.mediaUrl !== this.content.url) {
						this.isCaching = true;
						this.resetCache(this.mediaId, this.mediaUrl);
					} else {
						this.lottiedatachange(this.mediaId, this.mediaUrl);
					}
					this.lottieCheckDimension(this.mediaUrl);
				}


				this.saveMedia(isSame);
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
		this.isRequired = false;
		this.isLoading = true;
		this.$nextTick(() => {
			this.initData();
		});
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 300);
	},
};
</script>
